// Lecture des réserves conservées dans les extensions historiques.
import type { ManqueCalcul } from '../api/types';

export type ManqueAffiche = Pick<ManqueCalcul, 'code' | 'objet' | 'description'> & { nom?: string; libelle?: string };

/** Les instantanés historiques sont des extensions JSON, pas des réponses typées. */
export function lireManques(valeur: unknown): ManqueAffiche[] {
  if (!Array.isArray(valeur)) return [];
  return valeur
    .filter((m): m is ManqueAffiche => !!m && typeof m === 'object'
      && m.code === 'agent_sans_zone' && typeof m.objet === 'string' && typeof m.description === 'string')
    .map((m) => ({
      code: m.code,
      objet: m.objet,
      description: m.description,
      ...(typeof m.nom === 'string' ? { nom: m.nom } : {}),
      ...(typeof m.libelle === 'string' ? { libelle: m.libelle } : {}),
    }));
}
